// src/templates/size-chart-element.js
var createSizeChartElement = (sizeChartData) => {
  let buttons = "";
  let measurements = "";
  let bodyHeights = "";
  let counter = 0;
  function wrapNumbers(str) {
    str = str.replace(/([0-9]+)/g, '<span data-original="$1" data-number>$1</span>');
    return str;
  }
  function wrapSizes(str) {
    str = str.replace(/\b(\w*cm\w*)\b/g, "<span data-metric-holder>$1</span><br>");
    return str;
  }
  sizeChartData.data.sizes.forEach((size) => {
    if (size.age == "" || size.size == "" || size.size == null || size.body_height == "") {
      return false;
    }
    const sizes = size.size.split("||");
    let measurement = "";
    let body_height = wrapNumbers(size.body_height);
    body_height = wrapSizes(body_height);
    sizes.forEach((el) => {
      el = wrapNumbers(el);
      el = wrapSizes(el);
      measurement += el;
    });
    if (counter == 0) {
      buttons += `<button type="button" class="button button--size js-size-active" data-size="${size.age}">${size.age}</button>`;
      bodyHeights += `<p class="js-size-active" data-size="${size.age}">${body_height}</p>`;
      measurements += `<div data-size="${size.age}" class="measurement js-size-active">${measurement}</div>`;
    } else {
      buttons += `<button type="button" class="button button--size" data-size="${size.age}" class="size">${size.age}</button>`;
      bodyHeights += `<p class="" data-size="${size.age}">${body_height}</p>`;
      measurements += `<div data-size="${size.age}" class="measurement">${measurement}</div>`;
    }
    counter++;
  });
  return `
    <div class="size-chart-holder">
      <div class="size-chart-holder__image-holder">
        <img src="${sizeChartData.data.image}">
      </div>

      <div class="size-chart-holder__chart">
        <div class="chart__switcher switcher">
          <div class="input input--switch">
            <span class="js-toggle-switch" data-value="cm">cm</span><input type="checkbox" name="size-guide-unit" data-off-value="cm" data-on-value="inch"><span class="js-toggle-switch" data-value="inch">inch</span>
          </div>
        </div>
        
        <div class="chart__info">
          <h5 class="info__title">${window.translations.select_age}</h5>
          <div class="sizes">
            ${buttons}
          </div>
          <!-- end .sizes -->

          <h5 class="info__title">${window.translations.body_height}</h5>
          <div class="body-height">
            ${bodyHeights}
          </div>
          <!-- end .body-height -->

          <h5 class="info__title">${window.translations.product_measurements}</h5>
          <div class="measurements">
              ${measurements}
            <!-- end .measurement -->
          </div>
          <!-- end .measurements -->
        </div>

      </div>

    </div>
    <!-- end .modal -->
  `;
};

// src/extenders/size-guide-chart.js
var SizeGuideModal = class extends HTMLElement {
  constructor() {
    super();
    const sizeGuideModalElement = this;
    const allSizeChartDataElements = document.querySelectorAll(".size-chart-data");
    const allSizeChartData = [];
    const sizeGuideId = sizeGuideModalElement.getAttribute("data-size-guide-id");
    const sizeChartHolderElement = sizeGuideModalElement.querySelector(".size-chart-holder");
    allSizeChartDataElements.forEach((sizeChartDataElement) => {
      const sizeChartData = JSON.parse(sizeChartDataElement.innerHTML).sizecharts;
      sizeChartData.map((sizeChart) => {
        allSizeChartData.push(sizeChart);
      });
    });
    const correctSizeGuideData = allSizeChartData.find((sizeChart) => sizeChart.id === sizeGuideId);
    if (!correctSizeGuideData)
      return;
    const newSizeChartElement = createSizeChartElement(correctSizeGuideData);
    if (newSizeChartElement) {
      sizeChartHolderElement.insertAdjacentHTML("beforeend", newSizeChartElement);
      const newSizeChartHolderElement = sizeGuideModalElement.querySelector(".size-chart-holder");
      const unitElement = newSizeChartHolderElement.querySelector('input[name="size-guide-unit"]');
      const cmLabelElement = sizeGuideModalElement.querySelector('.js-toggle-switch[data-value="cm"]');
      const inchLabelElement = sizeGuideModalElement.querySelector('.js-toggle-switch[data-value="inch"]');
      const handleUpdateUnit = (newUnit) => {
        const currentUnit = newUnit ? newUnit : "cm";
        const allSizeButtonElements = newSizeChartHolderElement.querySelectorAll(".button--size");
        const allDataNumbers = sizeGuideModalElement.querySelectorAll("[data-number]");
        const allMetricHolderElements = sizeGuideModalElement.querySelectorAll("[data-metric-holder]");
        allDataNumbers.forEach((dataNumberElement) => {
          if (currentUnit === "inch") {
            const size = dataNumberElement.getAttribute("data-original");
            const newSize = (Math.round(size / 2.54 * 100) / 100).toFixed(1);
            dataNumberElement.innerHTML = newSize;
            allMetricHolderElements.forEach((metricHolderElement) => {
              metricHolderElement.innerHTML = "inch";
            });
            unitElement.checked = true;
          }
          if (currentUnit === "cm") {
            const size = dataNumberElement.getAttribute("data-original");
            dataNumberElement.innerHTML = size;
            allMetricHolderElements.forEach((metricHolderElement) => {
              metricHolderElement.innerHTML = "cm";
            });
            unitElement.checked = false;
          }
        });
        if (allSizeButtonElements) {
          allSizeButtonElements.forEach((sizeButtonElement) => {
            sizeButtonElement.addEventListener("click", (event) => {
              event.preventDefault();
              allSizeButtonElements.forEach((sizeButtonElement2) => {
                sizeButtonElement2.classList.remove("js-size-active");
              });
              const newSize = event.target.getAttribute("data-size");
              const allMeasurementElements = sizeGuideModalElement.querySelectorAll(".measurement");
              const allBodyHeightElements = sizeGuideModalElement.querySelectorAll("p");
              allMeasurementElements.forEach((measurementElement) => {
                measurementElement.classList.remove("js-size-active");
                if (measurementElement.getAttribute("data-size") === newSize) {
                  measurementElement.classList.add("js-size-active");
                }
              });
              allBodyHeightElements.forEach((bodyHeightElement) => {
                bodyHeightElement.classList.remove("js-size-active");
                if (bodyHeightElement.getAttribute("data-size") === newSize) {
                  bodyHeightElement.classList.add("js-size-active");
                }
              });
              event.target.classList.add("js-size-active");
            });
          });
        }
      };
      handleUpdateUnit();
      unitElement == null ? void 0 : unitElement.addEventListener("change", () => handleUpdateUnit((unitElement == null ? void 0 : unitElement.checked) == true ? "inch" : "cm"));
      cmLabelElement.addEventListener("click", () => handleUpdateUnit("cm"));
      inchLabelElement.addEventListener("click", () => handleUpdateUnit("inch"));
    }
  }
};
if (customElements.get("size-guide-modal") === void 0) {
  customElements.define("size-guide-modal", SizeGuideModal);
}
